import { IoCheckmarkCircle } from "react-icons/io5";
import { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Analytics, Gtag } from '../compornents/Analytics';
import React from 'react';

// 注文完了（bag-first / 2026-09-01）。
//
// この画面の役割はお礼ではなく「誤解を潰すこと」。
// 新しい動線ではここで一度流れが切れ、次のアクション（集荷依頼）はお客様の操作待ちになる。
// そして最も起きやすい失敗が「バッグを届けに来た配達員に依頼品を渡そうとする」で、
// これをやられるとUber側は受け取れず、依頼品も出せず、双方の時間が無駄になる。
// そのため②で明示的に否定し、③で「もう一度アプリから」を予告してマイページへ送る。
export const OrderDone = () => {
  const navigate = useNavigate();
  const { order_id } = useParams();

  useEffect(() => {
    Gtag('view_order_done');
    window.scrollTo(0, 0);
  }, []);

  const toHome = () => {
    navigate(order_id ? `/home/${order_id}` : '/home');
  };

  return (
    <div className="App">
      <Analytics title="ご注文ありがとうございます" />
      <div className="Home">
        <div className="home_contents text-center" style={{ paddingTop: 32 }}>
          <IoCheckmarkCircle style={{ fontSize: 64, color: '#1f9e58' }} aria-hidden="true" />
          <div className="h5 mt-3 mb-4">ご注文ありがとうございます</div>

          <div className="bf-todo">
            <div className="bf-todo_title">このあとの流れ</div>
            <div className="bf-todo_step">
              <span className="bf-todo_num">1</span>
              <span className="bf-todo_text">
                まず専用バッグを<b>無料</b>でお届けします
              </span>
            </div>
            <div className="bf-todo_step">
              <span className="bf-todo_num">2</span>
              <span className="bf-todo_text">
                <span className="bf-ng">お届けした配達員に依頼品はお渡しできません。</span><br />
                バッグを受け取ったら、依頼品(3点まで)をバッグに入れてください
              </span>
            </div>
            <div className="bf-todo_step">
              <span className="bf-todo_num">3</span>
              <span className="bf-todo_text">
                準備ができたら、<b>もう一度アプリから集荷を依頼</b>してください
                <small>マイページのボタンからいつでも依頼できます</small>
              </span>
            </div>
          </div>

          <button className="button-next bf-cta" onClick={toHome}>マイページへ</button>
        </div>
      </div>
    </div>
  );
}

export default OrderDone;
